// utils/formatString.js
export const formatUnderscoreToSpace = (str) => {
  return str.replace(/_/g, " ");
};

export const formatToDateTimeLocal = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  // Offset the UTC time by the local timezone minutes
  const offset = date.getTimezoneOffset() * 60000;
  const localISOTime = new Date(date.getTime() - offset).toISOString();

  // Returns "YYYY-MM-DDTHH:mm"
  return localISOTime.substring(0, 16);
};
